import { inject, Injectable, Type } from '@angular/core';

import { TASK_DETAILS_RENDERERS } from '../contracts/task-details.contract';
import { TaskType } from '../models/task.interface';

@Injectable()
export class TaskDetailsRegistry {
  private readonly componentsByType = new Map<TaskType, Type<unknown>>();

  constructor() {
    const renderers = inject(TASK_DETAILS_RENDERERS, { optional: true }) ?? [];
    for (const renderer of renderers) {
      this.componentsByType.set(renderer.type, renderer.component);
    }
  }

  componentFor(type: TaskType): Type<unknown> | null {
    return this.componentsByType.get(type) ?? null;
  }
}
